import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { FAQS } from "@/data/exceptionHub";
import { EASE } from "@/lib/motion";

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-24 md:py-32 bg-white" data-testid="section-faq">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <Reveal><span className="text-xs font-semibold uppercase tracking-[0.15em] text-brand">FAQ</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-navy tracking-tight leading-tight text-balance">Questions, answered.</h2>
          </Reveal>
        </div>

        <div className="mt-12 divide-y divide-slate-100 border-y border-slate-100">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} data-testid={`faq-item-${i}`}>
                <button onClick={() => setOpen(isOpen ? -1 : i)} data-testid={`faq-trigger-${i}`}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group" aria-expanded={isOpen}>
                  <span className={`font-heading text-lg md:text-xl font-medium tracking-tight transition-colors ${isOpen ? "text-navy" : "text-ink-700 group-hover:text-navy"}`}>{item.q}</span>
                  <span className={`grid place-items-center h-8 w-8 rounded-full border shrink-0 transition-all duration-300 ${isOpen ? "bg-navy border-navy text-white rotate-45" : "bg-white border-slate-200 text-ink-500 group-hover:border-slate-300"}`}>
                    <Plus className="h-4 w-4" strokeWidth={2} />
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.4, ease: EASE }} className="overflow-hidden">
                      <p className="pb-6 pr-14 text-ink-500 leading-relaxed">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
